import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteLocation = ({
    setIsDeleteLocation,
    selectedData,
    deleteLocationLoading,
    deleteLocationMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteLocationMutate({
            id: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteLocation}
            title="Confirm Deletion"
        >
            <WarningText>
                {/* Are you sure you want to delete this location? */}
                Are you sure you want to delete the location ‘{selectedData?.name}’?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteLocationLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteLocationLoading ? "Loading..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteLocation;